import { useState } from "react";
import { ModalMenuItem, ModalSubmenu } from "../../../components";
import { useTenantFeatures } from "../../../hooks";

interface ServiceTopbarProps {
  onChangeTab: (tab: string) => void;
}

export const ServiceTopbar = ( { onChangeTab } : Readonly<ServiceTopbarProps>) => {

  const { manageServiceTypes } = useTenantFeatures();
  const [activeTab, setActiveTab] = useState<string>(manageServiceTypes ? 'Details' : 'Locations');

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    onChangeTab(tab);
  };

  const items: ModalMenuItem[] = [
    ...(manageServiceTypes ? [{
      label: 'Details',
      url: '',
      clickHandler: () => handleTabChange('Details'),
      ifActive: activeTab === 'Details' ? 'active' : '',
    }] : []),
    {
      label: 'Locations',
      url: '',
      clickHandler: () => handleTabChange('Locations'),
      ifActive: activeTab === 'Locations' ? 'active' : '',
    },
  ]

  return <ModalSubmenu className="p-0" items={items} />;
};

export default ServiceTopbar;
